/**
 * Day arithmetic on `YYYY-MM-DD` strings, in the shape `personal/server/util/dates.ts` and
 * `business/server/util/dates.ts` already use (ARCHITECTURE §3: pure UTC arithmetic, never
 * `new Date(dayString)` in local time).
 *
 * Duplicated here rather than imported because `shared/insight` may not reach into a system's
 * `server/` tree. Only the two helpers the bucketing needs are copied.
 */
import type { DayString } from './types.ts';

const DAY_RE = /^\d{4}-\d{2}-\d{2}$/;

/** True for a syntactically valid `YYYY-MM-DD`. Calendar validity is the caller's business. */
export function isDayString(v: unknown): v is DayString {
  return typeof v === 'string' && DAY_RE.test(v);
}

function utc(day: DayString): number {
  return Date.UTC(Number(day.slice(0, 4)), Number(day.slice(5, 7)) - 1, Number(day.slice(8, 10)));
}

/** Whole days from `a` to `b` (`b − a`). Negative when `b` is in the past. */
export function daysBetween(a: DayString, b: DayString): number {
  return Math.round((utc(b) - utc(a)) / 86_400_000);
}
